import * as _ from 'lodash';
import { useEffect, useState } from 'react';
import { Button, FormControl, FormGroup, ControlLabel, HelpBlock, Alert, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    container: any,
    startingEmail: string,
    onSendEmail: (donorEmail: string) => void,
    onCancel: () => void
}

const DonorConnectEmailConfirmation = (props: IProps) => {
    const [donorEmail, setDonorEmail] = useState('');
    const [donorEmailValid, setDonorEmailValid] = useState(true);
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        setDonorEmail(props.startingEmail);
    }, [props]);

    const handleCancel = () => {
        props.onCancel();
    };

    const handleFromChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        setDonorEmail(e.currentTarget.value);
    };

    const handleSubmit = () => {
        let valid = validate();

        setDonorEmailValid(valid);
        setDirty(true);

        if (valid) {
            props.onSendEmail(donorEmail);
        }
    };

    const validate = () => {
        return donorEmail != '' && isEmailValid(donorEmail);
    };

    const isEmailValid = (val) => {
        let regEmail = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!regEmail.test(val)) {
            return false;
        }

        return true;
    };

    const isValid = dirty ? donorEmailValid : true;

    return (
        <>
            <Modal backdrop='static' show={props.show} onHide={handleCancel} style={{ zIndex: 99999999 }} container={props.container}>
                <Modal.Header closeButton>
                    Connect with Donor Mentor
                </Modal.Header>

                <Modal.Body>
                    {!isValid && (
                        <Alert bsStyle='danger' bsSize='sm'>Please complete the items in red below</Alert>
                    )}

                    <Alert bsStyle='warning' bsSize='sm'>
                        Please enter the e-mail of the donor you would like to invite.  If that donor is registered, we will give them a link to connect their profile with the Donor Mentor system.
                        If the profile with that e-mail does not exist, nothing will happen and we will not be able to tell you which action we took due to privacy issues.
                    </Alert>

                    <FormGroup validationState={!donorEmailValid ? 'error' : null}>
                        <ControlLabel>Donor (email):</ControlLabel>
                        <FormControl
                            value={donorEmail}
                            onChange={handleFromChange}
                            placeholder={'e.g. jsmith@wxyz.com'}
                        />

                        {!donorEmailValid && (
                            <HelpBlock>Email is required</HelpBlock>
                        )}
                    </FormGroup>
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle='primary' onClick={handleSubmit}>Send Email</Button>
                    <Button onClick={handleCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
    // }
}

export default DonorConnectEmailConfirmation;
